import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "send-late"
}
const _hoisted_2 = { class: "agreement" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PSwitcher = _resolveComponent("PSwitcher")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_p_button = _resolveComponent("p-button")!
  const _component_PopUp = _resolveComponent("PopUp")!
  const _component_CheckBoxComp = _resolveComponent("CheckBoxComp")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PSwitcher, {
      label: "Отправить позже",
      modelValue: _ctx.checked,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checked) = $event)),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchSendLate()))
    }, null, 8, ["modelValue"]),
    (_ctx.form?.send_late && _ctx.form.send_late > 0 && _ctx.checked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.date.toLocaleString()), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_PopUp, {
      modalOpen: _ctx.modalOpen,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modalOpen = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DatePicker, {
          modelValue: _ctx.date,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.date) = $event)),
          mode: "dateTime",
          is24hr: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_p_button, {
          style: {"margin-top":"20px"},
          title: "Отправить позже",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setSendLate()))
        })
      ]),
      _: 1
    }, 8, ["modalOpen"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CheckBoxComp, {
        modelValue: _ctx.agreemntChecked,
        "onUpdate:modelValue": [
          _cache[5] || (_cache[5] = ($event: any) => ((_ctx.agreemntChecked) = $event)),
          _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update', _ctx.agreemntChecked)))
        ]
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", {
        class: _normalizeClass(["agreement-text", {'agreement-checked': _ctx.agreemntChecked, error: !_ctx.valid}]),
        onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.agreemntChecked = !_ctx.agreemntChecked; _ctx.$emit('update', _ctx.agreemntChecked)})
      }, "Подтверждаю, что получено согласие на обработку и передачу персональных данных клиента", 2)
    ])
  ], 64))
}